export default __webpack_public_path__ + "static/media/undo.8de8eeb4.svg";